import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.defaults.timeout = 45000;

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ") || null;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/** Mensagem amigável a partir de erro axios/rede. */
export function formatApiError(err) {
  const fromBody = formatApiErrorDetail(err?.response?.data?.detail);
  if (fromBody) return fromBody;
  if (err?.code === "ERR_NETWORK" || err?.message === "Network Error") {
    return "Não foi possível conectar à API. Verifique a rede ou tente de novo.";
  }
  if (err?.code === "ECONNABORTED") return "A requisição demorou demais. Tente novamente.";
  return err?.message || "Algo deu errado. Tente novamente.";
}

export const brl = (v) =>
  (v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export default api;
